
skrilla.directive('skrillaTabs', function () {
    return {
        templateUrl: 'directives/tabs/tabs.html',
        scope: {
            tabs: "=",
            selected: "=",
            key: "=",
            selectedChangeFn: "="
        },
        controller: function ($scope, objectChangeService) {
            var key = $scope.key + "Tab"
            objectChangeService.registerObject(key, "selected", $scope);



            $scope.init = function (){
                var urlParams = new URLSearchParams(window.location.hash);
                if(($scope.selected === 0 || $scope.selected === null || $scope.selected === undefined) && urlParams.has(key)){
                    $scope.selected = parseInt(urlParams.get(key));
                    updateQueryStringParameter()
                    updateFn();
                }
                listen();
            }

            function listen() {
                objectChangeService.listenForChange(key, function () {
                    updateQueryStringParameter();
                    updateFn();
                }, "selected")
            }

            function updateFn(){
                if ($scope.selectedChangeFn !== null && $scope.selectedChangeFn !== undefined && typeof $scope.selectedChangeFn === 'function') {
                    $scope.selectedChangeFn($scope.selected);
                }
            }


            function updateQueryStringParameter() {
                var uri = window.location.href;
                var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
                var separator = uri.indexOf('?') !== -1 ? "&" : "?tabs&";
                if (uri.match(re)) {
                    window.location.href = uri.replace(re, '$1' + key + "=" + $scope.selected + '$2');
                }
                else {
                    window.location.href = uri + separator + key + "=" + $scope.selected;
                }
            }

        }
    };
});
